 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/Titlepage'
 import A7815040844061 from '@/components/97815040844061'
 import A78150408440622 from '@/components/978150408440622'
 import A78150408440623 from '@/components/978150408440623'
 import A78150408440624 from '@/components/978150408440624'
 import A78150408440625 from '@/components/978150408440625'
 import A78150408440626 from '@/components/978150408440626'
 import A78150408440627 from '@/components/978150408440627'
 import A78150408440628 from '@/components/978150408440628'
 import A78150408440629 from '@/components/978150408440629'
 import A78150408440630 from '@/components/978150408440630'
 import A78150408440631 from '@/components/978150408440631'
 import A78150408440632 from '@/components/978150408440632'
 import A78150408440633 from '@/components/978150408440633'
 import A78150408440634 from '@/components/978150408440634'
 import A78150408440635 from '@/components/978150408440635'
 import LOVE_2 from '@/components/love_2'
 import A78150408440636 from '@/components/978150408440636'
 import COPYRIGHT from '@/components/copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Titlepage",
 			"name" : "Titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/97815040844061",
 			"name" : "97815040844061",
 			"component" : A7815040844061
 		},
 		{
 			"path" : "/978150408440622",
 			"name" : "978150408440622",
 			"component" : A78150408440622
 		},
 		{
 			"path" : "/978150408440623",
 			"name" : "978150408440623",
 			"component" : A78150408440623
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js